export const PROPOSAL_STATE = 'proposal';
export const LOADER_CSV_STATE = 'loader';
export const PROGRESS_LOADING = 'progress_loading';
export const PROGRESS_DONE = 'progress_done';
export const RESULT_STATE = 'result';
export const SELECT_FULFILLMENT = 'select_fulfillment';